module.exports = __webpack_public_path__ + "img/logo-rossignol.1c8c95c0.svg";